import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { element } from 'protractor';

@Injectable()
export class UserService {

  getFotosBackup(dni, sexo) { 
    return this._http.get(`${this.urlUser}/auth/imgsBackup?dni=${dni}&sexo=${sexo}`, this.httpOptions()); 
  }

  eliminarValidacion(validacion_id: any) {
    return this._http.delete(`${this.urlUser}/auth/auditoria/validaciones/${validacion_id}`,this.httpOptions());
  }

    urlUser: string = `${environment.api}`;
    auth: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

    constructor(
        private _http: HttpClient
    ) {
        this.auth.next(this.isUserLogged());
    }

    registerUser(user) { return this._http.post(`${this.urlUser}/auth/register`, user, this.httpOptions()); }

    login(credentials) {
        return this._http.post(`${this.urlUser}/login`, credentials).toPromise().then(
            (response: any) => {
                localStorage.setItem('tivtk', response.token);
                localStorage.setItem('permissions', response.permissions);
                localStorage.setItem('newPermissions', JSON.stringify(response.newPermissions));
                localStorage.setItem('user', response.usuario);
                console.log(response);
                
                this.auth.next(true);
                return response;
            }
        );
    }

    forgot(email) { return this._http.post(`${this.urlUser}/forgot`, email, this.httpOptions()); }

  reset(user) { return this._http.post(`${this.urlUser}/reset`, user, this.httpOptions()); }

  getEmail() { return this._http.get(`${this.urlUser}/auth/getEmail`, this.httpOptions()); }

    isUserLogged(): boolean { return localStorage.getItem('tivtk') ? true : false; }

    getUsersPermissions(): string { return localStorage.getItem('permissions'); }
    logout() {
      localStorage.removeItem('tivtk');
      localStorage.removeItem('permisos');
      this.auth.next(false);
    }

    getUsers() { return this._http.get(`${this.urlUser}/auth/getUsers`, this.httpOptions()); }

    getEmpresa() { return this._http.get(`${this.urlUser}/auth/getEmpresa`, this.httpOptions()); }

    deleteUser(email: string) { return this._http.post(`${this.urlUser}/auth/delete`, { email }, this.httpOptions()); }

    sendNotification(notification: any) { return this._http.post(`${this.urlUser}/auth/notification`, notification, this.httpOptions()); }

    httpOptions() {
        const token = localStorage.getItem('tivtk');
        return {
            headers: new HttpHeaders({
                'token': token ? token : ''
            })
        };
    }


    unsubscribe(token) { return this._http.get("https://api.autenticartuid.com/vida/admin/unsubscribe?token="+token) }


    getWebNotifications(){
        return this._http.get(`${this.urlUser}/auth/webnotifications`, this.httpOptions());
    }


    
    getAlerts(){
        return this._http.get(`${this.urlUser}/auth/alerts`, this.httpOptions());
    }


    getUsuariosSoporte(){
        return this._http.get(`${this.urlUser}/auth/tickets/users`, this.httpOptions());
    }

    getTicketsSoporte(estado, asignado, prioridad,text){
        let params = "?";
        if(estado) params+= `estado=${estado}`;
        if(asignado) params+= `&asignacion=${asignado}`;
        if(prioridad) params+= `&prioridad=${prioridad}`;
        if(text && text.length>0) params+= `&text=${text}`;
        return this._http.get(`${this.urlUser}/auth/tickets` + params, this.httpOptions());
    }

    putTicketStatus(el, newStatus){
        return this._http.put(`${this.urlUser}/auth/tickets/${el.proveedor}/${el.external_id}/status/` + newStatus, {},this.httpOptions());
    }

    assignTicket(el, newUser){
        return this._http.put(`${this.urlUser}/auth/tickets/${el.proveedor}/${el.external_id}/asign/` + newUser, {},this.httpOptions());
    }

    setTicketEnProceso(el, enProceso){
        enProceso = enProceso==1?true:false;
        return this._http.put(`${this.urlUser}/auth/tickets/${el.proveedor}/${el.external_id}/procesando/` + enProceso, {},this.httpOptions());
    }


    descargarValidacioneRegistracionessMes(isValidations,empresa: string, mes: number, ano: number) {
        return this._http.get(`${this.urlUser}/auth/reports/dashboard/${isValidations?'validations':'registrations'}?empresa=${empresa}&mes=${mes}&ano=${ano}`,this.httpOptions());
      }

      getTicketCloseReasons() {
        return this._http.get(`${this.urlUser}/auth/tickets/categories`,this.httpOptions());
      }

      postTicketCategory(el: any, code: any) {
        return this._http.post(`${this.urlUser}/auth/tickets/HS/${ el.external_id }/category`, { category: code},this.httpOptions());
      }

      ticketSoporteModificarCanal(external_id: any, value: any) {
        return this._http.put(`${this.urlUser}/auth/tickets/HS/${external_id}/channel/${value}`, {},this.httpOptions());
        
      }

      getAuditorias(filters){
        return this._http.get(`${this.urlUser}/auth/auditoria/validaciones?` + filters,this.httpOptions());
      }

      auditar(tipo, id, resultado){
          ///auth/auditoria/validaciones/:id/ok
        return this._http.get(`${this.urlUser}/auth/auditoria/${tipo}/${id}/${resultado}`,this.httpOptions());
      }

      getRegistrationReport(index){
    //     router.get('/auth/reports/pending’— USUARIOS CON CERTIFICACION PENDIENTE
    //     router.get('/auth/reports/tickets/monthly - REPORTE DE TICKETS MENSUAL
    //     router.get('/auth/reports/tickets/daily’- REPORTE DE TICKETS DIARIO
        let path = "/reports/pending";
        if(index==1) path = "/reports/tickets/monthly";
        if(index==2) path = "/reports/tickets/daily";
        return this._http.get(`${this.urlUser}/auth${path}`,this.httpOptions());
      }



      //// REGISTROS MANUALES APP 
      getRegistrosManuales(){
        return this._http.get(`${this.urlUser}/auth/manuales`,this.httpOptions());
      }


      getManaualImages(dni, sexo){
        return this._http.get(`${this.urlUser}/auth/manuales/images?document=${dni}&gender=${sexo}`,this.httpOptions());
      }

      acceptManual(id: any) {
        return this._http.get(`${this.urlUser}/auth/manuales/accept/${id}`,this.httpOptions());
      }

      rejectManual(id){
        return this._http.get(`${this.urlUser}/auth/manuales/delete/${id}`,this.httpOptions());
      }
      // FIN REGISTROS MANUALES APP


      // FORMULARIOS DINAMICOS
      getFormularios(){
        return this._http.get(`${this.urlUser}/auth/formularios`,this.httpOptions());
      }

      getRespuestasFormularios(formulario, cuit){
        return this._http.get(`${this.urlUser}/auth/respuestas?formulario=${formulario}`,this.httpOptions());
      }

      // FIIN FORMULARIOS DINAMICOS

      addTextExtra(id_usuario: any, text: string) {
        console.log("Seteando extra a usuario " + id_usuario + " :" + text);
        return this._http.put(`${this.urlUser}/auth/registrados/${id_usuario}/extra`, { text: text},this.httpOptions()); 
      }

      enviarmaildefraude(cuil: any) {
        return this._http.get(`${this.urlUser}/auth/auditoria/sendMail?cuil=${cuil}`,this.httpOptions());
      }
}
